import React, { useState } from "react";
import { InView } from 'react-intersection-observer';
import HeaderAnim from "../utils/animations/textRevealAnimation";


export default function PageIntro(props) {
  const { title, header, content, classes } = props.data;
  const [isVisible, setIsVisible] = useState(false);
  return (
    <InView onChange={(inView) => setIsVisible(inView)} threshold={[0.1]}>
      <div className={`page-intro-section section-gap-small ${classes}`} id={props.id ? props.id : ''}>
        <div className="container">
          <p className="theme-color-title">{isVisible && <HeaderAnim header={title} />}</p>
          <h2 className="h3">{header}</h2>
          <div className="row two-col-content d-flex flex-wrap align-v-center">
            <div className="col">
              <blockquote>
                <h6>Every $1 invested in user experience design results in $100 (9,900%) ROI. </h6>
                <p><span>Forrester Research</span></p>
              </blockquote>
            </div>
            <div className="col">
              {content}
            </div>
          </div>
        </div>
      </div>
    </InView>
  );
}